import { OrganizationDetails } from "@/components/organizations/OrganizationDetails"
import { BeakerIcon, BuildingOffice2Icon, UsersIcon } from "@heroicons/react/24/outline"
import { useEffect } from "react"
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom"
import { useApp } from "../AppProvider"
import { EditOrganization } from "../components/organizations/EditOrganization"
import { OrganizationList } from "../components/organizations/OrganizationList"
import { TestConfigTable } from "../components/testConfig/TestConfigTable"
import { EditUser } from "../components/users/EditUser"
import { UserList } from "../components/users/UserList"
import { classNames } from "../utils/classNames"

export const SuperAdminPage = () => {
  const { user } = useApp()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (!user?.superAdmin) {
      navigate("/")
    }

    // Go to default tab
    if (pathname === "/private") {
      navigate("/private/organizations")
    }
  }, [user?.superAdmin, navigate, pathname])

  const routes = [
    { title: "Organizations", href: "/private/organizations", icon: BuildingOffice2Icon },
    { title: "Users", href: "/private/users", icon: UsersIcon },
    { title: "Lab Values", href: "/private/lab-values", icon: BeakerIcon },
  ]

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-6">
      <nav className="card flex flex-col md:col-span-1">
        <ul className="-mx-4">
          {routes.map((route) => (
            <li key={route.title}>
              <Link
                to={route.href}
                className={classNames(
                  pathname.includes(route.href)
                    ? "text-primary-600 bg-gray-50"
                    : "hover:text-primary-600 text-gray-700 hover:bg-gray-50",
                  "group flex items-center gap-x-2 rounded-md p-2 text-sm leading-6 font-semibold",
                )}
              >
                <route.icon
                  className={classNames(
                    pathname.includes(route.href)
                      ? "text-primary-600"
                      : "group-hover:text-primary-600 text-gray-400",
                    "h-4 w-4 shrink-0",
                  )}
                  aria-hidden="true"
                />
                {route.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div className="md:col-span-5">
        <Routes>
          <Route path="/*">
            <Route path="lab-values" element={<TestConfigTable />} />
            <Route path="organizations" element={<OrganizationList />} />
            <Route path="organizations/:organizationId" element={<OrganizationDetails />} />
            <Route path="organizations/:organizationId/edit" element={<EditOrganization />} />
            <Route path="users/:userId" element={<EditUser />} />
            <Route path="users" element={<UserList showOrganization />} />
            <Route path="" element={<OrganizationList />} />
          </Route>
        </Routes>
      </div>
    </div>
  )
}
